export const HEADER_CONSTANTS = {
  MOBILE_SOURCE: 'website',
  DESKTOP_SOURCE: 'desktop_web',
} as const;

export const MEDIA_QUERIES = {
  MIN_DESKTOP: '(min-width: 560px)',
} as const;
